import { apiService } from './api';
import type { ApiResponse } from '@/types/apiResponse';

interface RecordConsentResult {
  /** How many rows the server wrote; zero when the user had already accepted. */
  recorded: number;
}

/**
 * The body carries no document ids, no version and no timestamp: the server resolves
 * what is currently live and stamps its own clock, so the record says what the user
 * was actually shown rather than what the client claims.
 */
export const consentService = {
  async acceptOnboardingConsent(): Promise<ApiResponse<RecordConsentResult>> {
    return apiService.post<
      ApiResponse<RecordConsentResult>,
      { platform: string }
    >('/private/api/v1/consents', { platform: 'WEB' });
  },
};
